import { render, staticRenderFns } from "./box8.vue?vue&type=template&id=1307b0a7&scoped=true&"
import script from "./box8.vue?vue&type=script&lang=js&"
export * from "./box8.vue?vue&type=script&lang=js&"
import style0 from "./box8.vue?vue&type=style&index=0&id=1307b0a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307b0a7",
  null
  
)

export default component.exports